import cn from "classnames";
import Image, { ImageProps } from "next/image";
import { forwardRef, useState } from "react";

type Props = ImageProps & {
  imageLoaded?: () => void;
};

export default forwardRef<HTMLImageElement, Props>(function NextImage(props: Props, ref) {
  const [loading, setLoading] = useState(true);

  const { imageLoaded, src, alt, className, ...rest } = props;

  const handleImageLoading = () => {
    setLoading(false);
    imageLoaded?.();
  };

  return (
    <Image
      ref={ref}
      src={src}
      alt={alt || ""}
      className={cn(className, loading ? "backgroundGradientLight" : undefined)}
      {...rest}
      onLoad={handleImageLoading}
      onErrorCapture={handleImageLoading}
    />
  );
});
